<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import VSelect from "@/components/ui/VSelect.vue";
import paymentMethodsApi from "../api/resources/paymentMethodsApi";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getOptions() {
      paymentMethodsApi.index().then((response) => {
        this.options = response.data.map((method) => {
          return { text: method.name, value: method.id };
        });
      });
    },
  },

  created() {
    this.getOptions();
  },
};
</script>

<style></style>
